export default "__VITE_ASSET__DnutszLc__"